import { HttpResult } from "widgets-for-react";
import { DossierPageData } from "../../sharepointPageApi/types/pageData";
import { ChildDossiers } from "./childDossiersBlockState";

export const childDossiersBlockApi = async (id?: number): Promise<HttpResult<ChildDossiers>> => {
    const res = id
      ? await fetch(`/api/v1/pages/dossier-children/${id}`)
      : await fetch(`/api/v1/pages/dossier-children`);

    if (!res.ok)
      return {
        kind: 'failed',
        status: res.status,
      }

    const data: DossierPageData[] = await res.json();

    return {
      kind: 'result',
      status: 200,
      value: data.map((child) => ({
        title: child.HeaderTitle,
        slug: child.AbsolutePath,
      })),
    };
  }
